import { DataLayerTracker } from "./datalayer";
import { YandexMetrika } from "./yandex-metrika";



export class Tracker {
    construct(data) {
        this.data = data;
        this.dataLayer = new DataLayerTracker(data);
        this.yandexMetrika = new YandexMetrika();
        this.init();
        this.backendPageViewed();
    }

    init() {
        this.dataLayer.init();
    }

    isUserAuthorized() {
        return this.data.user.authorized;
    }

    backendPageViewed() {


        console.log(this.data);

        switch (this.data.route) {
            case "index":
                this.indexPageViewed();
                break;
            case "products":
                this.categoryPageViewed();
                break;
            case "product":
                this.productPageViewed();
                break;
            /*case 'cart':
                this.basketPageViewed();
                break;*/
            case "order":
                this.orderPageViewed();
                break;
            // это фейковый маршрут, но страница эта отдельная
            case "order.thankyoupage":
                this.orderThankyouPageViewed();
                break;
            case "404":
                this.notFoundPageViewed();
                break;
            case "search":
                this.searchPageViewed();
                //this.productPageViewed();
                break;
            default:
                this.otherPageViewed();
                break;
        }
    }

    clientTimeSite(time = 190000) {
        const _self = this;
        setTimeout(function () {
            _self.yandexMetrika.timeClient();
        }, time);
    }

    indexPageViewed() {}

    categoryPageViewed() {
        this.dataLayer.categoryPageView(this.data.products);
    }

    productPageViewed() {
        this.dataLayer.productPageView(this.data.product);
        this.dataLayer.productAnalogPageView(this.data.analogProduct);
        this.dataLayer.productViewedPageView(this.data.viewedProduct);
    }

    basketPageViewed() {
        this.dataLayer.basketPageView(this.data.basket);
    }

    orderPageViewed() {
        this.dataLayer.orderPageView(this.data.basket);
    }
    orderThankyouPageViewed() {
        this.yandexMetrika.purchase();
        // try {
        //     this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
        // } catch (e) {
        //     console.log(e.message());
        // }

    }

    searchPageViewed() {
        this.dataLayer.productPageSearch(this.data.search);
    }

    otherPageViewed() {}

    notFoundPageViewed() {}

    showroomSend() {
        this.yandexMetrika.roomSent();
    }
    headerClickPhone() {
        this.yandexMetrika.clickPhone();
    }
    footerClickPhone() {
        this.yandexMetrika.clickPhoneFooter();
    }
    callMeSend() {
        this.yandexMetrika.callMe();
    }
    commentSend() {
        this.yandexMetrika.addComment();
    }
    calculationSend() {
        this.yandexMetrika.calcSend();
    }
    partnerSend() {
        this.yandexMetrika.partSend();
    }
    addToCart() {
        this.yandexMetrika.addProduct();
    }
}

window.ozinkovkaTracker = new Tracker();
